import { produce } from "immer";
import {
  type AffiliateActions,
  CHANGE_SALES_PARTNER,
  CLEAR_SALES_PARTNER,
  UPDATE_SUBSIDIARY,
} from "~/domains/affiliate/redux/actions";

export interface AffiliateStore {
  savedAffiliate?: SalesPartnerDTO;
  previousSavedAffiliate?: SalesPartnerDTO;
  savedSubsidiaryId?: string;
  previousSavedSubsidiaryId?: string;
  visitedAffiliate?: SalesPartnerDTO;
}

export const preferredSalesPartnerInitialState: AffiliateStore = {
  savedAffiliate: window.SCHA.savedSalesPartner ?? undefined,
  savedSubsidiaryId: window.SCHA.affiliate?.selectedSubsidiaryId ?? undefined,
  visitedAffiliate: window.SCHA.visitedSalesPartner ?? undefined,
};

export const affiliateReducer = (
  state = preferredSalesPartnerInitialState,
  action: AffiliateActions,
): AffiliateStore => {
  return produce(state, (draft) => {
    switch (action.type) {
      case CHANGE_SALES_PARTNER: {
        const { subsidiaryId, affiliate } = action.payload;
        draft.previousSavedAffiliate = draft.savedAffiliate;
        draft.savedAffiliate = affiliate;
        draft.previousSavedSubsidiaryId = draft.savedSubsidiaryId;
        draft.savedSubsidiaryId = subsidiaryId;
        break;
      }

      case CLEAR_SALES_PARTNER: {
        delete draft.savedAffiliate;
        break;
      }

      case UPDATE_SUBSIDIARY: {
        // Don't save previous value.
        // draft.previousSavedSubsidiaryId = draft.savedSubsidiaryId;
        draft.savedSubsidiaryId = action.payload;
        break;
      }
    }
  });
};
